import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, useMemo, forwardRef, useImperativeHandle } from 'react';
import { createTaroEvent, createTaroFormSubmitEvent } from '../_util/taroEvent';
import FormContext from './formContext';
const Form = ({ className, style, children, onSubmit, onReset }, ref) => {
    const form = useRef(null);
    useImperativeHandle(ref, () => form.current);
    const listeners = useRef([]);
    const values = useRef({});
    const context = useMemo(() => ({
        subscribe(fn) {
            listeners.current.push(fn);
            return () => {
                for (let i = 0; i < listeners.current.length; i++) {
                    if (listeners.current[i] === fn) {
                        listeners.current.splice(i, 1);
                        return;
                    }
                }
            };
        },
        collect(name, value) {
            if (name) {
                values.current[name] = value;
            }
        }
    }), []);
    return (_jsx("form", Object.assign({ ref: form, className: className, style: style, onSubmit: event => {
            event.preventDefault();
            values.current = {};
            for (const fn of listeners.current) {
                fn();
            }
            const taroEvent = createTaroFormSubmitEvent(form.current, values.current);
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(taroEvent);
        }, onReset: event => {
            event.stopPropagation();
            const taroEvent = createTaroEvent('reset', event.target, {});
            onReset === null || onReset === void 0 ? void 0 : onReset(taroEvent);
        } }, { children: _jsx(FormContext.Provider, Object.assign({ value: context }, { children: children })) })));
};
export default forwardRef(Form);
